import AppRouter from './AppRouter';

export default AppRouter;

export * from './AppRouteNameList';
export * from './AppRoutePathList';
export * from './AppPathList';

export * from './routes';
